import Reaction from '../../model/Reaction'
import styles from './ChatScreen.module.css'

export interface ChatReactionDisplayProps {
  reactions: Reaction[]
  side: 'own' | 'other' | 'card'
}

export default function ChatReactionDisplay({ reactions, side }: ChatReactionDisplayProps) {
  if (reactions.length === 0) return null

  const emojis: string[] = []
  for (const reaction of [...reactions].reverse()) {
    if (!emojis.includes(reaction.emoji)) emojis.push(reaction.emoji)
  }

  const sideClass =
    side === 'own'
      ? styles.reactionBadgeOwn
      : side === 'card'
        ? styles.reactionBadgeCard
        : styles.reactionBadgeOther

  return (
    <span className={[styles.reactionBadge, sideClass].join(' ')}>
      {emojis.map((emoji) => (
        <span key={emoji} aria-hidden="true">
          {emoji}
        </span>
      ))}
      {reactions.length > 1 && <span className={styles.reactionCount}>{reactions.length}</span>}
    </span>
  )
}
